export const POPPINS = '"Poppins", sans-serif'
